import React from 'react';
import { Row, Col, Table, Image, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FaDollarSign } from 'react-icons/fa';
import './OrderComponent.css';


const OrderComponent = ({ order }) => {
  const { orderId, orderBy, orderFrom, orderPlaced, totalAmount, products } = order;
// console.log('products', products);
  const currentUser = useSelector((state) => state.user.user);
  const isManagerView = currentUser?.role === "manager";

  return (
    <Container className="order-container">
      <Row className="mb-4">
        <Col xs={12} md={2}>
        <p>
          <strong>Order ID</strong>
        <br />
        <span>
          {orderId}
          </span>
          </p> 
        </Col>
        <Col xs={12} md={2}>
        <p>
          <strong>
            
            Order By
            </strong> 
          <br />
          <span>
          {orderBy}
          </span>
          </p>
        </Col>
        <Col xs={12} md={2}>
        <p>
          <strong>
            
            Order From
            </strong> 
          <br />
          <span>
          {orderFrom}
          </span>
          </p>
        </Col>
        <Col xs={12} md={3}>
        <p>
          <strong>Order Placed</strong> 
          <br />
          <span>
         {orderPlaced}
         </span>
         </p>
        </Col>
        {!isManagerView && (
          <Col xs={12} md={3} >
            <p>
              <strong>Total Amount</strong>
              <br />
              <span>
               PKR {totalAmount}
               </span>
            </p>
          </Col>
        )}
      </Row>

   
    
          {products.map((product, index) => (
            <>
            <Row key={index} className='product-row'>
              <Col lg={1}>
                <Image src={product.image} alt={product.name} rounded className='product-small-image'  />
              </Col>
              <Col lg={9}>
              <p className='product-name'><strong>{product.name}</strong>
                <p className='m-0 p-0'>
              {product.unit}
              </p>
              </p>
              </Col>
              <Col lg={2} className='product-price text-end'>PKR {product.price}</Col>
             
                  </Row>
                   <hr></hr>
                   </>
                  
          ))}
    
    

      {!isManagerView && (
        <Row className="mt-4">
          <Col xs={9} className="text-start">
            <strong>Total</strong>
          </Col>
          <Col xs={3} className="product-price text-end">
            PKR {totalAmount}
          </Col>
        </Row>
      )}

      {/* Product images at the end */}
      <Row className="mt-3">
        <h4>Photos</h4>
        <Col xs={12} className="d-flex justify-content-start" style={{ gap: '10px' }}>
        {products.map((product, index) => (
  <div key={index} className="product-item">
    <Image
      src={product.image}
      alt={product.name}
      rounded
      className='related-photo'
    />
    {/* <p><span>Oct 14, 10:24 AM</span></p> */}
  </div>
))}

</Col>

      </Row>
    </Container>
  );
};


  


export default OrderComponent;
